import { useContext } from "react"
import { SideRailContext } from "../components/SideRail/SideRailContext"
import { useSelector } from "react-redux"
import { ReduxState } from "../common/types"

/**
 * Custom hook that checks if the current side rail has unsaved changes
 * This is a hook instead of a selector because it needs to access the side rail config
 * @returns {boolean} True if there are unsaved changes in the current side rail
 */
export const useSideRailHasChanges = (): boolean => {
    const { sideRailConfig } = useContext(SideRailContext)
    const sourceData = useSelector((state: ReduxState) => state.sourceData?.sourceData)

    // If sourceData is not available, there can be no changes
    if (!sourceData) return false

    // We only care about changes for DATA_TABLE flow, since that's the only place
    // we have changes to manage in the side rail (to my knowledge)
    if (sideRailConfig.flow !== "DATA_TABLE") return false

    // Get the resource data for the current side rail
    const resource = sideRailConfig.resource
    const resourceData = sourceData[resource] ?? []

    // If there is no data, there can be no changes
    if (!resourceData.length) return false

    // If there are any new rows or modified rows, there are changes
    return resourceData.some(row => row.modified || row.newRow)
}
